/** Marcas já salvas, desenhadas sobre a página.
 *
 * `pointer-events: none` é decisão consciente: destaque clicável rouba a seleção
 * de texto na mesma área, e interagir com um destaque existente (trocar cor,
 * apagar, ir para) acontece no painel lateral — que é navegável por teclado, o
 * que o clique no retângulo nunca seria.
 */
import type { Highlight } from '@/types/api'

interface HighlightLayerProps {
  destaques: Highlight[]
}

export function HighlightLayer({ destaques }: HighlightLayerProps) {
  return (
    <div className="pdf-highlight-layer" aria-hidden="true" data-testid="pdf-highlight-layer">
      {destaques.flatMap((h) => {
        // `rects` pinta linha a linha; sem ele, o envolvente cobriria a margem
        // inteira numa seleção de várias linhas.
        const areas = h.rects?.length ? h.rects : h.rect ? [h.rect] : []
        return areas.map((r, i) => (
          <span
            key={`${h.id}-${i}`}
            className={`pdf-highlight pdf-highlight--${h.color}`}
            data-testid={`highlight-${h.id}`}
            style={{
              left: `${r.x * 100}%`,
              top: `${r.y * 100}%`,
              width: `${r.w * 100}%`,
              height: `${r.h * 100}%`,
            }}
          />
        ))
      })}
    </div>
  )
}
